<template>
  <main class="legal">
    <div class="container">
      <router-link
        class="legal__back"
        to="/"
      >← {{ data.legal.backLabel }}</router-link>
      <h1 class="legal__title">{{ data.legal.title }}</h1>

      <!-- sommaire : les liens du pied de page pointent sur ces ancres -->
      <nav
        v-if="data.legal.sections.length > 1"
        class="legal__toc"
      >
        <a
          v-for="section in data.legal.sections"
          :key="section.slug"
          :href="`#${section.slug}`"
          @click.prevent="goTo(`#${section.slug}`)"
        >{{ section.title }}</a>
      </nav>

      <section
        v-for="section in data.legal.sections"
        :id="section.slug"
        :key="section.slug"
        class="legal__section"
      >
        <h2>{{ section.title }}</h2>
        <!-- texte Strapi (Markdown) échappé puis mis en forme : cf. utils/markdown.js -->
        <div
          class="legal__body"
          @click="onBodyClick"
          v-html="markdown(section.body)"
        />
      </section>
    </div>
  </main>
</template>

<script>
import { markdown } from '@/utils/markdown'
import { scrollToAnchor } from '@/utils/scroll'

export default {
  name: 'LegalView',
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  methods: {
    markdown,
    goTo(anchor) {
      history.replaceState(null, '', anchor)
      scrollToAnchor(anchor)
    },
    // renvois internes du texte (« voir la Politique de confidentialité ») : défilement
    // sous l'en-tête collant plutôt que le saut brut du navigateur
    onBodyClick(e) {
      const link = e.target.closest('a[href^="#"]')
      if (!link) return
      e.preventDefault()
      this.goTo(link.getAttribute('href'))
    }
  }
}
</script>

<style lang="scss" scoped>
.legal {
  background: $white;
  padding: 60px 0 90px;
  min-height: 60vh;

  .container {
    max-width: 860px;
  }
}

.legal__back {
  display: inline-block;
  margin-bottom: 26px;
  font-size: 13px;
  font-weight: 600;

  &:hover {
    color: $cyan;
  }
}

.legal__title {
  font-size: clamp(26px, 3vw, 36px);
  font-weight: 700;
  color: $blue;
}

.legal__toc {
  display: flex;
  flex-wrap: wrap;
  gap: 10px 26px;
  margin-top: 20px;
  padding-bottom: 24px;
  border-bottom: 1px solid #E3ECF1;

  a {
    font-size: 14px;
    font-weight: 600;
    color: $teal;

    &:hover {
      color: $blue;
      text-decoration: underline;
    }
  }
}

.legal__section {
  margin-top: 48px;

  h2 {
    font-size: clamp(22px, 2.2vw, 26px);
    font-weight: 700;
    color: $navy;
    margin-bottom: 14px;
  }
}

// mise en forme du Markdown (contenu injecté : sélecteurs :deep)
.legal__body {
  font-size: 14.5px;
  line-height: 1.7;

  :deep(h3) {
    margin: 28px 0 8px;
    font-size: 17px;
    font-weight: 700;
    color: $ink;
  }

  :deep(h4) {
    margin: 18px 0 4px;
    font-size: 15px;
    font-weight: 700;
    color: $teal;
  }

  :deep(p) {
    margin: 0 0 12px;
  }

  :deep(ul) {
    margin: 0 0 12px;
    padding-left: 22px;
  }

  :deep(li) {
    margin-bottom: 4px;
  }

  :deep(a) {
    color: $teal;
    text-decoration: underline;
    word-break: break-word;

    &:hover {
      color: $blue;
    }
  }
}
</style>
